'use client';

import { useEffect, useState } from 'react';

import { getClientHost } from '../utils/getDomainInfo';

export const useGetClientHost = () => {
  const [clientHost, setClientHost] = useState<string | null>(null);

  useEffect(() => {
    setClientHost(getClientHost());
  }, []);

  return clientHost;
};
